import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8ef1b902&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8ef1b902&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef1b902",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\User\\Documents\\legalmerge-prod\\legal-merge\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ef1b902')) {
      api.createRecord('8ef1b902', component.options)
    } else {
      api.reload('8ef1b902', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8ef1b902&scoped=true", function () {
      api.rerender('8ef1b902', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/analytics-tabs/components/call-center-data/index.vue"
export default component.exports